export default __webpack_public_path__ + "static/mobile-bg-analytic-88f00e53c357c1e698d43b4e626d25d4.png";